module.exports = __webpack_public_path__ + "static/img/7.d353a78.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/4/zh/7.png
// module id = rgG1
// module chunks = 0